module.exports = __webpack_public_path__ + "static/media/icon_system_social_youtube.431efeb9.svg";